import React from "react";
import AzureLoginButton from "../../materials/Buttons/AzureLoginButton";
import ChallanTextInput from "../../materials/Inputs/ChallanTextInput";

export default function SignInForm({ signIn }) {
  const [username, setUserName] = React.useState("");
  // const [password, setPassword] = React.useState("");
  const [fetchingToken, setFetchingToken] = React.useState(false);

  // const reRef = React.useRef();

  const onChangeUserName = (event) => {
    setUserName(event.target.value);
  };

  // const onChangePassword = (event) => {
  //   setPassword(event.target.value);
  // };

  // const submitLogInForm = async (e) => {
  //   e.preventDefault();
  //   const token = await reRef.current.executeAsync();
  //   reRef.current.reset();

  //   setFetchingToken(true);

  //   const payload = {
  //     username: username,
  //     password: password,
  //     recaptcha_token: token,
  //   };

  //   signIn(payload, setFetchingToken);
  // };

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
      }}
    >
      {/* <form onSubmit={submitLogInForm}>
        
        <ChallanPasswordInput
          id="password"
          label="Password"
          value={password}
          onChange={onChangePassword}
        />
        <ChallanSubmitButton
          onClick={submitLogInForm}
          disabled={fetchingToken}
          loading={fetchingToken}
        />
        <ReCAPTCHA
          sitekey={process.env.REACT_APP_RECAPTCHA_SITEKEY}
          size="invisible"
          ref={reRef}
        />
      </form> */}

      {/* <Box sx={{ my: 2, width: "100%" }}>
        <Divider>
          <Typography variant="body2" color="textSecondary">
            OR
          </Typography>
        </Divider>
      </Box> */}

      <ChallanTextInput
        id="username"
        label="Email"
        onChange={onChangeUserName}
        value={username}
      />
      <AzureLoginButton
        email={username.trim()}
        loading={fetchingToken}
        setLoading={setFetchingToken}
      />
    </div>
  );
}
